import React from 'react';
import BigArrowRight from 'assets/svg/big-arrow-right.svg';
import { Heading } from 'components/text';
import styles from './BenefitItem.module.scss';

type BenefitItemProps = {
  title: string;
  description: React.ReactNode;
};

const BenefitItem: React.FC<BenefitItemProps> = ({ title, description }) => (
  <article className={styles.benefitWrapper}>
    <div className={styles.title}>
      <BigArrowRight alt="Arrow pointing right" />
      <Heading as="h5" weight="demiBold">
        {title}
      </Heading>
    </div>
    <div className={styles.description}>{description}</div>
  </article>
);

export default BenefitItem;
